import { useFormik } from 'formik';
import { initialValues } from './formData'; // Importa los valores iniciales
import { validationSchema } from './formData';
import { MultiDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface CommunicationArchitectureForm {
    [key: string]: MultiDynamicField[];
}

export const useCommunicationArchitecture = (chatAssistant: ChatAssistant) => {
    const formikCommunicationArchitecture =
        useFormik<CommunicationArchitectureForm>({
            initialValues,
            validationSchema,
            onSubmit: console.log,
        });

    useEffect(() => {
        if (chatAssistant) {
            formikCommunicationArchitecture.setValues({
                communicationArchitecture:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.communicationArchitecture ??
                    initialValues.communicationArchitecture,
            });
        }
    }, [chatAssistant]);

    return { formikCommunicationArchitecture };
};
